import React from 'react';
import ComboGroupState from './comboGroupState/ComboGroupState';
import ComboGroupControlPanel from './components/ComboGroupControlPanel/ComboGroupControlPanel';
import ComboGroups from './components/ComboGroups/ComboGroups';
import { ModalWindows } from './components/ModalWindows';
import style from './index.module.scss';

const ComboGroupPage: React.FC = () => {
	return (
		<ComboGroupState>
			<div className={style.container} data-test="ComboGroupPage">
				<ComboGroupControlPanel />
				<ComboGroups />
				<ModalWindows />
			</div>
		</ComboGroupState>
	);
};

export default ComboGroupPage;
